import Collection from './collection.js';
import BulkUpload from 'newModels/bulk-upload.js';

export default class BulkUploads extends Collection {
    url() {
        if (this.company) {
            return `${this.company.url()}/bulkUploads`;
        }

        return '/BulkUploads';
    }

    initialize(models, {company = null} = {}) {
        super.initialize(...arguments);
        this.model = BulkUpload;
        this.company = company;
        this.pagination = false;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/bulk-uploads.js